export enum NameAddressSection {
  Shipper = 'shipper',
  Consignee = 'consignee',
  BillTo = 'billto'
}
